import { Sparkles } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';
import { BrowserFrame } from '../compass/shared';

// Section 7 — Ask Mylo, the AI sales assistant. Honest framing: grounded in
// the user's own CRM data; it drafts and suggests, the user decides.
export const ReachMylo = ({ sp }) => (
  <section aria-labelledby="reach-mylo-heading" data-testid="reach-mylo" className="relative overflow-hidden bg-navy-900 py-20 sm:py-28">
    <div className="grain-overlay" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="07"
        eyebrow="Ask Mylo"
        title="An AI sales assistant grounded in your CRM data"
        description={sp.myloCopy}
        dark
        testid="reach-mylo-header"
      />
      <Reveal className="mt-12">
        <BrowserFrame shot={sp.shots.mylo} label="Ask Mylo — AI sales assistant" data-testid="reach-mylo-visual" />
      </Reveal>
      <Reveal delay={0.1}>
        <h3 className="mt-10 text-xs font-bold uppercase tracking-[0.18em] text-slate-400">Things you can ask</h3>
        <ul className="mt-4 grid gap-3 sm:grid-cols-2" data-testid="reach-mylo-examples">
          {(sp.myloExamples || []).map((example) => (
            <li key={example} className="flex items-start gap-3 rounded-lg border border-white/10 bg-white/5 px-4 py-3.5 text-sm font-semibold text-slate-200">
              <Sparkles className="mt-0.5 h-4 w-4 shrink-0 text-service-growth" aria-hidden="true" />
              {example}
            </li>
          ))}
        </ul>
        <p className="mt-6 max-w-3xl rounded-lg border border-white/10 bg-white/5 p-4 text-sm font-medium leading-relaxed text-slate-300" data-testid="reach-mylo-note">
          {sp.myloNote}
        </p>
      </Reveal>
    </div>
  </section>
);
